import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';

export default class Pipe extends AContainer
{
    constructor(scene, ind)
    {
        super(scene);

        this.ind = ind;
    
        this.createPipe();
    }

    createPipe()
    {
        this.pipe = this.create(0, 0, "pipe");

        this.startX;
        this.startY;
        if(this.ind === 1){
            this.startX = 125;
            this.startY = -110;
        }
        else if(this.ind === 2){
            this.scaleX = -1
            this.startX = -125;
            this.startY = -110;
        }
        else if(this.ind === 3){
            this.startX = 70;
            this.startY = -140;
        }
        else if(this.ind === 4){
            this.scaleX = -1
            this.startX = -70;
            this.startY = -140;
        }

        this.setPosition(this.startX, this.startY);
    }

    createSmoke()
    {
        this.emitter = this.scene.add.particles(this.scene.particleAtlas, "SmokeParticle");
        this.emitter.createEmitter({
            alpha: { start: 1, end: 0 },
            scale: { start: 0.5, end: 2.5 },
            //tint: { start: 0xff945e, end: 0xff945e },
            speed: 20,
            accelerationY: -300,
            angle: { min: -85, max: -95 },
            rotate: { min: -180, max: 180 },
            lifespan: { min: 750, max: 1000 },
            blendMode: 'ADD',
            x: 32,
            y: -30
        });

        this.addAt(this.emitter, 0);
    }

    shake()
    {
        this.scene.killTween(this);

        var xPeriod1 = Phaser.Math.Between(1, 2);
        var yPeriod1 = Phaser.Math.Between(1, 2);

        this.scene.addTween(this, this.frequency, {x:this.startX + xPeriod1, y:this.startY + yPeriod1, yoyo:true, repeat:-1});
    }

    wiggle(aProgress, aPeriod1, aPeriod2) {
        let current1 = aProgress * Math.PI * 2 * aPeriod1;
        let current2 = aProgress * Math.PI * 2 * aPeriod2;
    
        return Math.sin(current1) * Math.cos(current2);
    }

    updateFrequency()
    {
        this.frequency;
        if(gameData.score === 1){
            this.createSmoke();
            this.frequency = 1000;
        }
        else if(gameData.score === 2){
            this.frequency = 750;
        }
        else if(gameData.score === 3){
            this.frequency = 500;
        }
        else if(gameData.score === 4){
            this.frequency = 250;
        }
        else if(gameData.score === 5){
            this.frequency = 175;
        }
        else if(gameData.score === 6){
            this.frequency = 125;
        }
        else if(gameData.score === 7){
            this.frequency = 100;
        }
        else if(gameData.score === 8){
            this.frequency = 75;
        }
        else if(gameData.score === 9){
            this.frequency = 50;
        }

        this.emitter.emitters.list[0].frequency = this.frequency;
        this.shake();
    }

    cleanUp()
    {
        this.scene.killTween(this);
        this.emitter.destroy();
        this.pipe.destroy();
    }
}